import type { ToastOptions } from '@evisort/eds/components/Toast/types';

type Enqueue = (options: ToastOptions) => string;

let enqueueToast: Enqueue | null = null;

export function registerShowToast(enqueue: Enqueue) {
  enqueueToast = enqueue;
}

export function unregisterShowToast() {
  enqueueToast = null;
}

export function showToast(options: ToastOptions) {
  if (!enqueueToast) {
    return undefined;
  }
  return enqueueToast(options);
}
